var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html, css } from 'lit';
import { customElement, state, property } from 'lit/decorators.js';
import { computePosition, autoUpdate } from '@floating-ui/dom';
let QboSearch = class QboSearch extends LitElement {
    constructor() {
        super(...arguments);
        this.payload = {};
        this.expanded = false;
        this.inputText = '';
        this.jsonListContainer = null;
        this.inputContainer = null;
    }
    static { this.styles = css `
    :host {
      display: inline-block;
      font-family: var(--qbo-font);
      margin-left: auto;
      vertical-align: top;
      float: right;
      position: relative;
    }
    input {
      border: 1px solid var(--qbo-border-color);
      border-radius: var(--qbo-border-radius);
      font-size: 0.9em;
      line-height: var(--qbo-line-height);
    }
    .collapsed {
      display: flex;
      align-items: center;
      width: fit-content;
      padding: 0.2em 0.5em;
      cursor: pointer;
    }
    .collapsed input {
      width: 5rem;
      transition: width 0.3s ease;
    }
    .collapsed input:focus {
      width: 15rem;
    }
    .input-container {
      display: flex;
      align-items: center;
      width: fit-content;
      border: 1px solid #ccc;
      padding: 0.2em 0.5em;
      position: relative;
    }
    .json-list {
      position: absolute;
      top: 100%;
      right: 0;
      background: white;
      border: 1px solid #ccc;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      padding: 0.5em;
      z-index: 10000;
    }
    .json-item {
      display: flex;
      gap: 5px;
      margin-bottom: 0.3em;
    }
    .json-item input {
      flex: 1;
      padding: 0.3em;
    }
    button {
      padding: 0.3em;
      font-size: 0.9em;
    }
    .search-icon {
      cursor: pointer;
      margin-left: 0.5em;
    }
    svg {
        height: 1rem;
        width: 1rem;
    }
  `; }
    render() {
        return html `
      ${!this.expanded
            ? html `
            <div class="collapsed" @click=${() => (this.expanded = true)}>
              <svg class="qbo-icon" @click=${() => (this.expanded = true)}><use href="/ui/images/qbo-icons.svg#search"></use></svg>
            </div>
          `
            : html `
            <div class="input-container">
              <input
                type="text"
                placeholder="Enter key:value"
                .value=${this.inputText}
                @input=${(e) => (this.inputText = e.target.value)}
                @keydown=${this.handleKeyDown}
                @blur=${() => (this.expanded = false)}
              />
              <svg class="qbo-icon" @click=${this.handleSearchClick}><use href="/ui/images/qbo-icons.svg#search"></use></svg>
            </div>
            <div class="json-list" id="json-list">
              ${Object.entries(this.payload).map(([key, value]) => html `
                  <div class="json-item">
                    <input
                      type="text"
                      .value=${key}
                      @input=${(e) => this.updateKey(e, key)}
                    />
                    <input
                      type="text"
                      .value=${value}
                      @input=${(e) => this.updateValue(e, key)}
                    />
                    <button @click=${() => this.deleteKeyValuePair(key)}>Delete</button>
                  </div>
                `)}
            </div>
          `}
    `;
    }
    firstUpdated() {
        this.updateFloatingPosition();
    }
    updated() {
        this.updateFloatingPosition();
    }
    async updateFloatingPosition() {
        if (this.inputContainer && this.jsonListContainer) {
            autoUpdate(this.inputContainer, this.jsonListContainer, async () => {
                const { x, y } = await computePosition(this.inputContainer, this.jsonListContainer, {
                    middleware: [],
                });
                Object.assign(this.jsonListContainer.style, {
                    left: `${x}px`,
                    top: `${y}px`,
                });
            });
        }
    }
    handleKeyDown(e) {
        if (e.key === 'Enter' && this.inputText.includes(':')) {
            const [key, value] = this.inputText.split(':').map(part => part.trim());
            if (key && value) {
                this.payload = { ...this.payload, [key]: value };
                this.inputText = '';
            }
        }
    }
    handleSearchClick() {
        this.expanded = false;
        this.dispatchEvent(new CustomEvent('change', {
            detail: { payload: this.payload },
            bubbles: true,
            composed: true,
        }));
    }
    updateKey(e, oldKey) {
        const newKey = e.target.value;
        if (newKey && newKey !== oldKey) {
            const { [oldKey]: _, ...rest } = this.payload;
            this.payload = { ...rest, [newKey]: this.payload[oldKey] };
        }
    }
    updateValue(e, key) {
        this.payload = { ...this.payload, [key]: e.target.value };
    }
    deleteKeyValuePair(key) {
        const { [key]: _, ...rest } = this.payload;
        this.payload = { ...rest };
    }
};
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], QboSearch.prototype, "payload", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], QboSearch.prototype, "expanded", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], QboSearch.prototype, "inputText", void 0);
QboSearch = __decorate([
    customElement('qbo-search')
], QboSearch);
export { QboSearch };
if (!customElements.get('qbo-search'))
    customElements.define('qbo-search', QboSearch);
